var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C9.44772 1 9 1.44772 9 2V4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6H20C20.5523 6 21 5.55228 21 5C21 4.44772 20.5523 4 20 4H15V2C15 1.44772 14.5523 1 14 1H10ZM13 4H11V3H13V4Z",
    fill: "#171E44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11C10.5523 11 11 11.4477 11 12V18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18V12C9 11.4477 9.44772 11 10 11Z",
    fill: "#171E44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12V18C13 18.5523 13.4477 19 14 19C14.5523 19 15 18.5523 15 18V12Z",
    fill: "#171E44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00001 7C3.71012 7 3.43449 7.1258 3.24455 7.3448C3.05462 7.5638 2.96906 7.85444 3.01006 8.14142L4.76475 20.4243C4.97588 21.9022 6.24165 23 7.7346 23H16.2654C17.7584 23 19.0241 21.9022 19.2353 20.4243L20.99 8.14142C21.031 7.85444 20.9454 7.5638 20.7555 7.3448C20.5655 7.1258 20.2899 7 20 7H4.00001ZM6.74465 20.1414L5.15302 9H18.847L17.2554 20.1414C17.185 20.6341 16.7631 21 16.2654 21H7.7346C7.23695 21 6.81503 20.6341 6.74465 20.1414Z",
    fill: "#171E44"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d40b8bf2eeeba48ccb2431b16f459b62.svg";
export { ForwardRef as ReactComponent };